webpackJsonp([190],{

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "微信 Vue 单页面应用设置标题 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1980:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1165),
  /* template */
  __webpack_require__(2179),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/wechat-document-title-316.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] wechat-document-title-316.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-410397a0", Component.options)
  } else {
    hotAPI.reload("data-v-410397a0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2179:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("微信 Vue 单页面应用设置标题")]), _vm._v(" "), _c('p', [_vm._v("在微信"), _c('code', [_vm._v("iOS")]), _vm._v(" "), _c('code', [_vm._v("webview")]), _vm._v("更新到"), _c('code', [_vm._v("WKWebView")]), _vm._v("之前我们可以通过加载一个 "), _c('code', [_vm._v("iframe")]), _vm._v(" 来实现单页面应用"), _c('code', [_vm._v("title")]), _vm._v("更改。但是17年初更新到 "), _c('code', [_vm._v("WKWebView")]), _vm._v(" 后该方法也失效。")]), _vm._v(" "), _c('p', [_vm._v("目前该问题已经解决，在微信 iOS 客户端 "), _c('code', [_vm._v("6.3.5")]), _vm._v(" 之后的版本都可以通过 "), _c('code', [_vm._v("document.title")]), _vm._v(" 设置标题了。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-410397a0", module.exports)
  }
}

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1980);

/***/ })

});


// WEBPACK FOOTER //
// 190.a26a6c68.js